import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d42e2b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "data-tag-wrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "data-tag__title" }


import { IDataTagProps } from './data-tag.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'data-tag',
  props: {
    props: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "data-tag",
      style: _normalizeStyle(`background: ${__props.props.color}`)
    }, [
      (__props.props.iconLocal)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "data-tag__icon",
            src: require(`@/assets/icons/emojis/${__props.props.iconLocal}`)
          }, null, 8, _hoisted_2))
        : (__props.props.iconCompleteUrl)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: __props.props.iconCompleteUrl,
              class: "data-tag__icon"
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_4, _toDisplayString(__props.props.title), 1)
    ], 4)
  ]))
}
}

})